export class LogRoutes
{
	static Home = "/";

	// Log
	static LogList(log_group_id: string)
	{
		return `/log/group/${log_group_id}/log/list`;
	}

	// LogGroup
	static LogGroupList = "/log/group/list";
	static LogGroupNew = "/log/group/new";
	static LogGroupCopy(id: string)
	{
		return `/log/group/${id}/new`;
	}
	static LogGroupEdit(id: string)
	{
		return `/log/group/${id}/edit`;
	}
	static LogGroupView(id: string)
	{
		return `/log/group/${id}/view`;
	}

	// Usage
	static Usage = "/usage";
}